/** Aligns with filter sections in FeedFiltersPane / Feed badge totals. */
export const FILTER_SECTION_KEYS_NON_FAIR = [
  'TYPE',
  'MEDIUM',
  'ON VIEW',
  'NEIGHBORHOOD',
  'SUBJECT',
  'STYLE',
];

export const FILTER_SECTION_KEYS_FAIR = ['TYPE', 'MEDIUM', 'SUBJECT', 'STYLE'];

export function countForFilterSection(counts, sectionKey) {
  switch (sectionKey) {
    case 'TYPE':
      return counts.showTypeCount;
    case 'MEDIUM':
      return counts.selectedMediumsCount;
    case 'ON VIEW':
      return counts.openCount;
    case 'NEIGHBORHOOD':
      return counts.selectedLocationCount;
    case 'SUBJECT':
      return counts.selectedSubjectCount;
    case 'STYLE':
      return counts.selectedStylesCount;
    default:
      return 0;
  }
}

/** Sum of selected chips across all filter categories shown in the sheet. */
export function totalSelectedFilterCount(counts, isFair) {
  const keys = isFair ? FILTER_SECTION_KEYS_FAIR : FILTER_SECTION_KEYS_NON_FAIR;
  return keys.reduce((sum, key) => sum + countForFilterSection(counts, key), 0);
}
